__turbopack_context__.v({
  "Arrow": "KCyVAW_Arrow",
  "ArrowFill": "KCyVAW_ArrowFill",
  "ArrowInnerStroke": "KCyVAW_ArrowInnerStroke",
  "ArrowOuterStroke": "KCyVAW_ArrowOuterStroke",
  "Item": "KCyVAW_Item",
  "ItemIndicator": "KCyVAW_ItemIndicator",
  "ItemIndicatorIcon": "KCyVAW_ItemIndicatorIcon",
  "ItemText": "KCyVAW_ItemText",
  "Popup": "KCyVAW_Popup",
  "ScrollArrow": "KCyVAW_ScrollArrow",
  "Select": "KCyVAW_Select",
  "SelectIcon": "KCyVAW_SelectIcon",
});
